import { call, put, takeEvery } from 'redux-saga/effects'
import * as userActions from '@redux/ducks/common/user.Ducks'
import * as userApi from '@apis/common/user.Api'

interface FetchLoginSaga {
  type: string
  payload: { username: string; password: string }
}

interface FetchUserListSaga {
  type: string
  payload: string
}

interface FetchUserDetailSaga {
  type: string
  payload: string
}

interface FetchRoleSaga {
  type: string
  payload: string
}

function* fetchLogin({ payload: { username, password } }: FetchLoginSaga) {
  try {
    const res: ReturnType<typeof userApi.login> = yield call(userApi.login, { username, password })
    yield put(userActions.loginSuccess(res))
  } catch (error) {
    yield put(userActions.loginFail(error))
  }
}

function* fetchListUser({ payload: queryString }: FetchUserListSaga) {
  try {
    const res: ReturnType<typeof userApi.getListUser> = yield call(userApi.getListUser, queryString)
    yield put(userActions.getListUserSuccess(res))
  } catch (error) {
    yield put(userActions.getListUserFail(error))
  }
}

function* fetchDetailUser({ payload: id }: FetchUserDetailSaga) {
  try {
    const res: ReturnType<typeof userApi.getUserDetail> = yield call(userApi.getUserDetail, id)
    yield put(userActions.getDetailUserSuccess(res))
  } catch (error) {
    yield put(userActions.getDetailUserFail(error))
  }
}

function* fetchListRole({ payload: query }: FetchRoleSaga) {
  try {
    const res: ReturnType<typeof userApi.getListUser> = yield call(userApi.getListUser, query)
    yield put(userActions.getListRoleSuccess(res))
  } catch (error) {
    yield put(userActions.getListRoleFail(error))
  }
}

function* fetchListProject() {
  try {
    const res: ReturnType<typeof userApi.getMyProject> = yield call(userApi.getMyProject)
    yield put(userActions.getListProjectSuccess(res))
  } catch (error) {
    yield put(userActions.getListProjectFail(error))
  }
}

function* fetchListMyDuAn() {
  try {
    const res: ReturnType<typeof userApi.getMyProject> = yield call(userApi.getMyProject)
    yield put(userActions.getListMyDuAnSuccess(res))
  } catch (error) {
    yield put(userActions.getListMyDuAnFail(error))
  }
}

function* fetchListMyChiNhanh() {
  try {
    const res: ReturnType<typeof userApi.getMyBranch> = yield call(userApi.getMyBranch)
    yield put(userActions.getListMyChiNhanhSuccess(res))
  } catch (error) {
    yield put(userActions.getListMyChiNhanhFail(error))
  }
}

export default function* watchUser() {
  yield takeEvery(userActions.login.toString(), fetchLogin)
  yield takeEvery(userActions.getListUser.toString(), fetchListUser)
  yield takeEvery(userActions.getDetailUser.toString(), fetchDetailUser)
  yield takeEvery(userActions.getListRole.toString(), fetchListRole)
  yield takeEvery(userActions.getListProject.toString(), fetchListProject)
  yield takeEvery(userActions.getListMyDuAn.toString(), fetchListMyDuAn)
  yield takeEvery(userActions.getListMyChiNhanh.toString(), fetchListMyChiNhanh)
}
